import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TrackLinkDirective } from '@analytics/events';

type IconName = 'user' | 'right-from-bracket';

@Component({
  selector: 'wl-navigation-service-button',
  standalone: true,
  imports: [CommonModule, FaIconComponent, TrackLinkDirective],
  templateUrl: './navigation-service-button.component.html',
  styleUrls: [
    './navigation-service-button.component.ed.scss',
    './navigation-service-button.component.essent.scss',
  ],
})
export class NavigationServiceButtonComponent {
  readonly href = input.required<string>();
  readonly text = input.required<string>();
  readonly iconName = input.required<IconName>();
  readonly hideText = input(false);
  readonly hideTextClass = computed(() =>
    this.hideText() ? 'button--hide-text' : ''
  );

  navigate = output();
}
